module.exports = __webpack_public_path__ + "img/linkmatch-model.19721f31.png";